import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { Http } from '@angular/http';
import { DashboardComponent } from '../views/Dashboard/dashboard.component';
import { TranslateModule, TranslateLoader, TranslateStaticLoader  } from 'ng2-translate';
import { ChartModule } from 'primeng/primeng';
import { DataGridModule } from 'primeng/primeng';
import { DialogModule } from 'primeng/primeng';
import { GalleriaModule } from 'primeng/primeng';
import { GrowlModule } from 'primeng/primeng';
import { PanelModule } from 'primeng/primeng';
import { DropdownModule } from 'primeng/primeng';
import { CalendarModule } from 'primeng/primeng';
import { TableModule } from 'primeng/table';
import { RoleGuardService as RoleGuard } from '../providers/authentication/role-guard.service';
import { Constantes } from '../domain/constantes';
import { AppChartComponent } from '../componentes/graficas/chart/chart.component';
import { AppHotChartComponent } from '../componentes/graficas/hotChart/hotChart.component';
import { RangefilterComponent } from '../componentes/graficas/rangeFilter/rangeFilter.component';
import { InfoDashComponent } from '../componentes/graficas/infoDash/infoDash.component';
import { PlanoModule } from 'interiores-mapa';
import { MapaCalorModule } from 'mapacalorcomponent/dist/mapa-calor';

import {
	BrowserAnimationsModule
  } from '@angular/platform-browser/animations';

import { BarChartDashComponent } from '../componentes/graficas/barChartDash/barChartDash.component';
import { Permisos } from '../providers/authentication/permisos.service';
import { version } from 'punycode';
import { ContenidosDashComponent } from '../componentes/graficas/contenidosDash/contenidosDash.component';

// import { ItsoftKibanaIntegrationModule} from '../../../../itsoft-kibana-integration/dist/itsoft-kibana-integration';


export const dashboardModuleRoutes: Routes = [
	{
		path: 'dashboard',
		component: DashboardComponent, // the `component` property is necessary when the lazy module provides some service in order to injection work well. If defined, the referenced component's template should have an element with the `<router-outlet>` directive.
		children: [
			{
				path: '',
				component: DashboardComponent ,
				canActivate: [RoleGuard],
				data: {
					expectedRole: [Permisos.Dashboard_menu]
				},
			}
		]
	}
];

@NgModule({
	imports: [
		CommonModule,
		FormsModule,
		RouterModule.forChild(dashboardModuleRoutes),
		CalendarModule,
		ChartModule,
		DropdownModule,
		DataGridModule,
		DialogModule,
		GalleriaModule,
		GrowlModule,
		PanelModule,
		MapaCalorModule,
		TableModule,
		PlanoModule,
		BrowserAnimationsModule,
		TranslateModule.forRoot({
            provide: TranslateLoader,
            useFactory: function(http: Http){ return new TranslateStaticLoader(http, '/assets/i18n', '.json'); },
            deps: [Http]
				}),
		// ItsoftKibanaIntegrationModule
	],

	declarations: [
		DashboardComponent,
		AppChartComponent,
		AppHotChartComponent,
		BarChartDashComponent,
		RangefilterComponent,
		InfoDashComponent,
		ContenidosDashComponent
	]

})

export class DashboardModule {

	static forRoot(): ModuleWithProviders {
		return {
		  ngModule: DashboardModule
		  // providers: [CreditCardService]
		};
	}

}



// WEBPACK FOOTER //
// C:/Users/adri9/Escritorio/admin-everpath/src/app/modules/dashboard.module.ts